import { useState, useRef, useEffect } from 'react';

interface HelpBubbleProps {
  content: string;
  /** Optional source citation */
  source?: string;
  /** Size variant */
  size?: 'sm' | 'md';
}

export default function HelpBubble({ content, source, size = 'sm' }: HelpBubbleProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const iconSize = size === 'sm' ? 'w-4 h-4 text-[10px]' : 'w-5 h-5 text-xs';

  return (
    <div className="relative inline-flex" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className={`${iconSize} rounded-full border border-ti-text-dim/30 text-ti-text-dim hover:border-ti-blue hover:text-ti-blue transition-colors cursor-pointer flex items-center justify-center font-medium leading-none`}
        aria-label="Help"
      >
        ?
      </button>

      {open && (
        <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 md:w-80">
          <div className="bg-[#1a1a2e] border border-ti-blue/30 rounded-lg shadow-xl shadow-black/40 p-4 space-y-2">
            <p className="text-xs text-ti-text leading-relaxed">{content}</p>
            {source && (
              <p className="text-[10px] text-ti-text-dim italic">{source}</p>
            )}
          </div>
          {/* Arrow */}
          <div className="flex justify-center">
            <div className="w-2 h-2 bg-[#1a1a2e] border-r border-b border-ti-blue/30 transform rotate-45 -mt-1" />
          </div>
        </div>
      )}
    </div>
  );
}
